import carbuyservice from "./clients/carBuyService"

export default {
    // get all active third party partners
    // change name
    getActiveThirdPartyPartners: async function () {
        return await carbuyservice.get('/thirdpartypartner/active');
    },
    // get all third party partners
    getAllThirdPartyPartners: async function () {
        return await carbuyservice.get('/thirdpartypartner');
    },
    create: async function (data) {
        return await carbuyservice.post('/thirdpartypartner', data, true)
    },
    update: async function (data) {
        return await carbuyservice.put('/thirdpartypartner', data, true)
    }
}


// WEBPACK FOOTER //
// ./src/api/thirdparty.js